// extracted by mini-css-extract-plugin
module.exports = {"recommender":"Hg-z"};